import type { CheckoutConfig } from '#types/config/checkout'

export default {
  clearSessionButtonVariant: 'secondary',
  showEmployeeInput: false
} satisfies CheckoutConfig['buyInStore']
